import Component from '../component/component';

import './languages.scss';

interface ILanguageSettings {
    activeClass: string;
    topClass: string;
}

export default class Languages extends Component {
    static initSelector: string = '.languages';

    public trigger: HTMLElement;

    settings: ILanguageSettings;

    constructor(target: HTMLElement) {
        super(target);

        this.trigger = this.element.querySelector('.languages__trigger');

        this.documentClickHandler = this.documentClickHandler.bind(this);

        this.settings = {
            activeClass: 'is-active',
            topClass: 'to-top',
        };

        this.init();
    }

    init(): void {
        this.trigger.addEventListener('click', this.toggleHandler.bind(this));
        this.element.addEventListener('keyup', this.keyboardHandler.bind(this));
    }

    addEventListeners(): void {
        document.addEventListener('click', this.documentClickHandler);
    }

    documentClickHandler(event: MouseEvent): void {
        if (event.target instanceof Element && !event.target.closest('.' + this.element.className.replace(/ /g, '.'))) {
            this.close();
        }
    }

    toggleHandler(event: Event): void {
        event.preventDefault();

        if (this.element.classList.contains(this.settings.activeClass)) {
            this.close();
        } else {
            this.open();
        }
    }

    keyboardHandler(event: KeyboardEvent): void {
        if (event.key === 'Escape') {
            this.close();
            this.trigger.focus();
        }
    }

    open(): void {
        if (this.getListDirection() === 'top') {
            this.element.classList.add(this.settings.topClass);
        } else {
            this.element.classList.remove(this.settings.topClass);
        }

        this.element.classList.add(this.settings.activeClass);
        this.trigger.setAttribute('aria-expanded', 'true');

        this.addEventListeners();
    }

    close(): void {
        this.element.classList.remove(this.settings.activeClass);
        this.trigger.setAttribute('aria-expanded', 'false');

        this.destroy();
    }

    getListDirection(): 'top' | 'bottom' {
        const elemTop: number = this.element.offsetTop;
        const windowTop: number = window.scrollY;
        const windowHeight: number = window.innerHeight;
        const elemHeight: number = this.element.clientHeight;
        const ddHeight: number = this.element.querySelector('.languages__list').clientHeight;

        if ((elemTop - windowTop + elemHeight + ddHeight) > windowHeight) {
            return 'top';
        } else {
            return 'bottom';
        }
    }

    destroy(): void {
        document.removeEventListener('click', this.documentClickHandler);
    }
}
